import type { GameHistoryNoteResponse } from "libs/apiClient";
import { _ } from "i18n";
import { GameHistoryUserAvatar } from "./GameHistoryUserAvatar";
import { GameHistoryLogChange } from "./GameHistoryLogChange";
import { formatLogTimestamp } from "./formatLogTimestamp";

interface GameHistoryLogCardProps {
	item: GameHistoryNoteResponse;
	gameStatusLabels: Record<string, string>;
}

export function GameHistoryLogCard({ item, gameStatusLabels }: GameHistoryLogCardProps) {
	const log = item.log;
	const author = item.createdBy?.name ?? _("discover.gameDetail.history.unknownUser");

	if (!log) {
		return null;
	}

	return (
		<article className="discoverGameHistory-logCard">
			<GameHistoryUserAvatar photo={item.createdBy?.photo} className="discoverGameHistory-logAvatar" />
			<div className="discoverGameHistory-logBody">
				<p className="discoverGameHistory-logMessage">
					<strong className="discoverGameHistory-logAuthor">{author}</strong>{" "}
					<GameHistoryLogChange log={log} gameStatusLabels={gameStatusLabels} />
				</p>
				<time className="discoverGameHistory-logTime" dateTime={item.createdAt}>
					{formatLogTimestamp(item.createdAt)}
				</time>
			</div>
		</article>
	);
}
